import { useCommonCodeStore } from "@/store/commonCodeStore";
import { useEquipStore } from "@/store/equipStore";
import { useEtcStore } from "@/store/etcStore";
import { useRouteStore } from "@/store/routeStore";
import { useSiteStore } from "@/store/siteStore";
import { useUserStore } from "@/store/userStore";
import { UserType } from '@/enums';
import Swal from "sweetalert2";
import { useDeviceStore } from "~/store/deviceStore";
import { useInstallerStore } from "~/store/installerStore";

export default defineNuxtRouteMiddleware(async (to, from) => {
	const siteStore = useSiteStore();
	const userStore = useUserStore();

	const commonCodeStore = useCommonCodeStore();
	const routeStore = useRouteStore();
	const equipStore = useEquipStore();
	const etcStore = useEtcStore();
  const deviceStore = useDeviceStore();
	const installerStore = useInstallerStore();


  deviceStore.setDevice();

  const route = useRoute();
	const router = useRouter();


	const ignoreURI = [
		"/toc/user/login"
	]
  
	const toLoginURI = [
		'/',
		'/toc',
		'/toc/'
	]

  const deviceType = deviceStore.device; 
  // const deviceType = "isMobile"; 

	const {$invokeNative} = useNuxtApp();

	const isAutoLoginCheck = ref(window.localStorage.getItem("autoLogin") ? window.localStorage.getItem("autoLogin") : 'false');

	const tocAutoLogin = useCookie('tocAutoLogin');

  const userToken = useCookie("userToken");
	const accessToken = userStore.apiTokenInfo?.accessToken;

  if (userToken === undefined || userToken.value === undefined || userToken.value === '') {
		isAutoLoginCheck.value = "false";
		tocAutoLogin.value = "false";
	}


	if(deviceType === 'isDesktop'){
		if(to.fullPath === '/'){
			setPageLayout("toc-non-side");
			return navigateTo('/toc');
		}
	}

  if(deviceType === 'isDesktop' && to.fullPath.includes('toc')){
		if(accessToken && userToken.value){
			userStore.isRefresh = false;
		}

		if(ignoreURI.findIndex(v => v === to.fullPath) !== -1){
			return;
		}

		if(toLoginURI.findIndex(v => v === to.fullPath) !== -1){
			if(Boolean(tocAutoLogin.value) === true){
				if(!accessToken){
					if(!userToken.value){
						setPageLayout("toc-non-side");
						return navigateTo('/toc/user/login');
					} else {
						userStore.refreshToken();
						return navigateTo('/toc/monitoring/newDashboard');
					}
				} else {
					return navigateTo('/toc/monitoring/newDashboard');
				}
			} else {
				setPageLayout("toc-non-side");
				return navigateTo('/toc/user/login');
			}
		} else {
			if(!to.fullPath.includes('/toc/user/login')){
				if(!accessToken){
					if(!userToken.value){
						alert("토큰이 만료되었습니다. 다시 로그인해주세요.");
						setPageLayout("toc-non-side");
						return navigateTo('/toc/user/login')
					} else {
						userStore.refreshToken();
					}
				}
			}
		
		}
	
	 if(to.fullPath === '/mobile/user/login'){
      if(isAutoLoginCheck.value === 'true'){
        return navigateTo('/mobile');
      }
    } else if(to.fullPath === '/mobile'){
      if(isAutoLoginCheck.value === 'true'){
        await userStore.refreshToken();
				const result = userStore.apiTokenInfo;
        login(result?.userSeq as number);
      }
    }
  } 
	else if(deviceType === 'isMobile'){
    if(to.fullPath === '/mobile/user/login'){
      if(isAutoLoginCheck.value === 'true'){
        return navigateTo('/');
      }
    } else if(to.fullPath === '/'){
      if(isAutoLoginCheck.value === 'true'){
        await userStore.refreshToken();
				const result = userStore.apiTokenInfo;
				login(result?.userSeq as number);
      } else {
				return navigateTo('/mobile');
			}
    }
  }
  


	async function login(userSeq: number) {
		// alert(`login : ${userSeq}`);

    await commonCodeStore.getInitAllCodeMap();

		installerStore.init();

		try {
			if (userSeq) {
				/** 코드 카테고리  */
				await commonCodeStore.getCodeCategories();
				/** 모든 코드 리스트 */
				await routeStore.makeRoutes();
				await commonCodeStore.getCities();
				// await userStore.getUsers(1, 1000, 2, "owner");
				if (userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin) {
					userStore.setMobileViewType('admin');

					await equipStore.initEquipList();
					// let mapInfo = await equipStore.getEquipMapData(userStore.loginUserInfo?.userSeq as number);
					etcStore.setFirstMap(true);
					etcStore.setFirstEquipList(true);
					router.replace(`/mobile/user/${userSeq}/equipMap`);
				} else if(userStore.getUserType === UserType.Worker){
					
					if(deviceStore.device === 'isMobile' && process.env.NODE_ENV === "production"){
						//@ts-ignore
						const gpsInfo = await $invokeNative.getLocation(false);
						console.log(JSON.stringify(gpsInfo));
						if(gpsInfo.isSuccess === true){
							installerStore.setWorkerGps(gpsInfo.data.latitude, gpsInfo.data.longitude);
						} 
						
						// else if(gpsInfo.errorCode === '-1'){
						
						// 	Swal.fire({
						// 		html: `<p style="font-size: 15px;">기기의 GPS 기능이 비활성화 상태입니다.<br>GPS 기능을 활성화해주세요.</p>`,
						// 		confirmButtonColor: "#1949e9",
						// 		confirmButtonText: "확인",
						// 		width: "85%",
						// 	});
						// } else if(gpsInfo.errorCode === '0'){
						// 	Swal.fire({
						// 		html: `<p style="font-size: 15px;">GPS의 권한을 획득하지 못하였습니다.<br>정확한 작업을 위해 GPS 권한허용을 승인해주세요.</p>`,
						// 		confirmButtonColor: "#1949e9",
						// 		confirmButtonText: "확인",
						// 		width: "85%",
						// 	});
						// }
					}
					router.replace('/mobile/installer/policy/all');

				} else {
					userStore.setMobileViewType('owner');

					await siteStore.getSiteList();

					await equipStore.initEquipList();
					await equipStore.setSelectSite(equipStore.convertSiteList[0].siteName);

					etcStore.setOwnerFirstStatus(true);

					router.replace(`/mobile/user/${userSeq}/views/status`);

				}
			} else {
				router.replace("/mobile/none-contents-page");
			}
		} catch (e) {
			alert(e);

			Swal.fire({
				html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
				confirmButtonColor: "#1949e9",
				confirmButtonText: "확인",
				width: "85%",
			});
		}
	}
	
	// async function login(userSeq: number) {
	// 	try {
	// 		if (userSeq) {
	// 			/** 코드 카테고리  */
	// 			await commonCodeStore.getCodeCategories();
	// 			/** 모든 코드 리스트 */
	// 			await commonCodeStore.getInitAllCode();
	// 			await routeStore.makeRoutes();
	// 			await commonCodeStore.getCities();
	// 			// await userStore.getUsers();

	// 			if (userStore.getUserType === UserType.Manager || userStore.getUserType === UserType.Admin) {
	// 				let result = await equipStore.getEquipList(userSeq);
	// 				// let mapInfo = await equipStore.getEquipMapData(userStore.loginUserInfo?.userSeq as number);
	// 				etcStore.setFirstMap(true);
	// 				etcStore.setFirstEquipList(true);
	// 				// let routeName = commonCodeStore.getEngSourceName(equipStore.selectEquipInfo.engSource as string);

	// 				router.replace(`/mobile/user/${userSeq}/equipMap`);
	// 			} else {
	// 				const siteResult = await siteStore.getSiteList(userSeq);

	// 				await siteStore.selectSite(siteResult[0], userSeq);
	// 				await equipStore.getEquipList(userSeq);
	// 				// await equipStore.set
	// 				await equipStore.setSelectSite(userSeq, equipStore.convertSiteList[0].siteName);

	// 				// etcStore.setFirstMap(false);
	// 				// etcStore.setFirstEquipList(false);
	// 				etcStore.setOwnerFirstStatus(true);

	// 				router.replace(`/mobile/user/${userSeq}/views/status`);
	// 			}
	// 		} else {
	// 			router.replace("/mobile/none-contents-page");
	// 		}
	// 	} catch (e) {

	// 		// alert();
	// 		Swal.fire({
	// 			html: `<p style="font-size: 15px;">오류가 발생하였습니다.<br>잠시 후 다시 시도해주세요.</p>`,
	// 			confirmButtonColor: "#1949e9",
	// 			confirmButtonText: "확인",
	// 			width: "85%",
	// 		})
	// 	}
	// }
});

